import React, { useState } from "react";
import type { StringSelectorOptionProps } from "../../types";
import { useColors } from "../../constants/useColors";
import { Button, Text, View } from "../../Components/Themed";
import { FlatList } from "react-native";
import { Icons } from "../../Components";

type StringSelectorProps = {
    active_value?:string,
    options: StringSelectorOptionProps[],
    onSelectOption:(option:StringSelectorOptionProps | undefined) => void
}
const StringSelector = ({ active_value, options, onSelectOption }:StringSelectorProps) => {
    const Colors = useColors();
    const [ visible, setVisible ] = useState(false);

    const active_option = options.find(o => o.value == active_value);


    const renderLeagues = (data:{ item:StringSelectorOptionProps, index:number }) => {
        return (
            <Button 
                transparent 
                style={{ flexDirection:'row', alignItems:'center', padding:10, borderRadius:0, borderBottomWidth:1, borderColor:Colors.borders.light }}
                onPress={() => { setVisible(false); onSelectOption(data.item) }}
            >
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{data.item.label}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.description}</Text>
                </View>
            </Button>
        )
    }

    return (
        <View style={{ padding:15 }} float>
            <Button transparent style={{ padding:0, flexDirection:'row', alignItems:'center' }} onPress={() => { setVisible(!visible); onSelectOption(undefined)}}>
                <Text style={{ flex:1, marginRight:10 }} theme='h1'>{active_option?.label ?? 'Select Option'}</Text>
                <Icons.ChevronIcon direction={visible?'up':'down'} color={Colors.text.h1} size={8} />
            </Button>
            {visible ?
            <View transparent style={{ marginTop:20 }}>
            <FlatList
                data={options.sort((a,b) => a.value.localeCompare(b.value))}
                key={'string_option_selector'}
                keyExtractor={item => item.value.toString()}
                renderItem={renderLeagues}
            />
            </View>
            :<></>}
        </View>
    )
}

export default StringSelector